import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, SendIcon } from 'lucide-react';
export function ContactUs() {
  return <main className="bg-[#F5F2ED] min-h-screen" data-id="element-123">
      <section className="py-20 bg-[#1B4332] text-white" data-id="element-124">
        <div className="container mx-auto px-4 text-center" data-id="element-125">
          <h1 className="text-5xl font-serif mb-6" data-id="element-126">Contact Us</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-127">
            We are here to support your journey toward restoration and wellness.
            Reach out to us today to schedule a consultation.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-128">
        <div className="container mx-auto px-4" data-id="element-129">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-130">
            <div data-id="element-131">
              <h2 className="text-3xl font-serif text-[#1B4332] mb-8" data-id="element-132">
                Get in Touch
              </h2>
              <div className="space-y-8" data-id="element-133">
                <div className="flex items-start gap-6" data-id="element-134">
                  <div className="w-12 h-12 bg-[#1B4332]/10 rounded-xl flex items-center justify-center text-[#1B4332] flex-shrink-0" data-id="element-135">
                    <MailIcon size={24} data-id="element-136" />
                  </div>
                  <div data-id="element-137">
                    <h4 className="font-bold text-[#1B4332] mb-1" data-id="element-138">Email Us</h4>
                    <p className="text-[#1A374D]/70" data-id="element-139">
                      info@globalrestorative.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-140">
                  <div className="w-12 h-12 bg-[#1B4332]/10 rounded-xl flex items-center justify-center text-[#1B4332] flex-shrink-0" data-id="element-141">
                    <PhoneIcon size={24} data-id="element-142" />
                  </div>
                  <div data-id="element-143">
                    <h4 className="font-bold text-[#1B4332] mb-1" data-id="element-144">Call Us</h4>
                    <p className="text-[#1A374D]/70" data-id="element-145">(555) 123-4567</p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-146">
                  <div className="w-12 h-12 bg-[#1B4332]/10 rounded-xl flex items-center justify-center text-[#1B4332] flex-shrink-0" data-id="element-147">
                    <MapPinIcon size={24} data-id="element-148" />
                  </div>
                  <div data-id="element-149">
                    <h4 className="font-bold text-[#1B4332] mb-1" data-id="element-150">Visit Us</h4>
                    <p className="text-[#1A374D]/70" data-id="element-151">
                      123 Wellness Way, Suite 100
                      <br data-id="element-152" />
                      City, State 12345
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-153">
                  <div className="w-12 h-12 bg-[#1B4332]/10 rounded-xl flex items-center justify-center text-[#1B4332] flex-shrink-0" data-id="element-154">
                    <ClockIcon size={24} data-id="element-155" />
                  </div>
                  <div data-id="element-156">
                    <h4 className="font-bold text-[#1B4332] mb-1" data-id="element-157">Hours</h4>
                    <p className="text-[#1A374D]/70" data-id="element-158">
                      Monday - Friday: 9am - 5pm
                      <br data-id="element-159" />
                      Saturday: By Appointment
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-10 rounded-3xl shadow-sm border border-[#1B4332]/5" data-id="element-160">
              <h3 className="text-2xl font-serif text-[#1B4332] mb-8" data-id="element-161">
                Send a Message
              </h3>
              <form className="space-y-6" data-id="element-162">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-163">
                  <div className="space-y-2" data-id="element-164">
                    <label className="text-sm font-bold text-[#1B4332] uppercase tracking-wider" data-id="element-165">
                      Full Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-[#1B4332]/10 focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" placeholder="John Doe" data-id="element-166" />
                  </div>
                  <div className="space-y-2" data-id="element-167">
                    <label className="text-sm font-bold text-[#1B4332] uppercase tracking-wider" data-id="element-168">
                      Email Address
                    </label>
                    <input type="email" className="w-full px-4 py-3 rounded-xl border border-[#1B4332]/10 focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" placeholder="john@example.com" data-id="element-169" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-170">
                  <label className="text-sm font-bold text-[#1B4332] uppercase tracking-wider" data-id="element-171">
                    Subject
                  </label>
                  <select className="w-full px-4 py-3 rounded-xl border border-[#1B4332]/10 focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" data-id="element-172">
                    <option data-id="element-173">Medical Services Inquiry</option>
                    <option data-id="element-174">Mental Wellness Coaching</option>
                    <option data-id="element-175">SYMBIS Marriage Coaching</option>
                    <option data-id="element-176">General Inquiry</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-177">
                  <label className="text-sm font-bold text-[#1B4332] uppercase tracking-wider" data-id="element-178">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-[#1B4332]/10 focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" placeholder="How can we help you?" data-id="element-179"></textarea>
                </div>
                <button className="w-full py-4 bg-[#1B4332] text-white font-bold rounded-xl hover:bg-[#143326] transition-all flex items-center justify-center gap-2" data-id="element-180">
                  <SendIcon size={20} data-id="element-181" />
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>;
}